import { useGrants } from '../../../auth/useCurrentUser'
import { GRANTS } from '../../../auth/grants'

/**
 * Panonun "Aksiyon Beklenen Maddeler" tablosunda **önceliklendirme** butonları ("Önceliklendir" ve
 * "Görevleri Önceliklendir") gösterilsin mi?
 *
 * <p>Karar {@link GRANTS.DASHBOARD_PRIORITIZE} yetkisinden okunur (2026-10-02). Yetki Genel Müdür
 * Yardımcısı ve Başkan rolüne **verilmez** (kullanıcı kararı 2026-10-01); önceden bu ayrım burada rol
 * kimliğine sabit bağlıydı, analist rol-yetki eşlemesini ekrandan yönetebilsin diye yetkiye taşındı.
 * İki pano da kuralı buradan okur.
 *
 * <p>Sunucudaki üç uç da aynı yetkiyle korunur — yetkisi olmayana buton gösterilmez çünkü basılsa
 * `403` dönerdi (fail-closed).
 */
export function useCanPrioritize(): boolean {
  const { hasGrant } = useGrants()
  return hasGrant(GRANTS.DASHBOARD_PRIORITIZE)
}
